import { render, staticRenderFns } from "./donor-payoff-recurring-plan.vue?vue&type=template&id=6a048a7a&scoped=true&"
import script from "./donor-payoff-recurring-plan.vue?vue&type=script&lang=js&"
export * from "./donor-payoff-recurring-plan.vue?vue&type=script&lang=js&"
import style0 from "./donor-payoff-recurring-plan.vue?vue&type=style&index=0&id=6a048a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a048a7a",
  null
  
)

export default component.exports